// extracted by mini-css-extract-plugin
export var bottomCircle = "bs_gZ";
export var content = "bs_bP";
export var description = "bs_c3";
export var hide = "bs_z";
export var icon = "bs_bz";
export var image = "bs_k";
export var imageContainer = "bs_g3";
export var left = "bs_b8";
export var nextYear = "bs_g2";
export var right = "bs_ck";
export var section = "bs_j";
export var shrink = "bs_g1";
export var title = "bs_g";
export var topCircle = "bs_gY";
export var wave = "bs_gF";
export var waveContainer = "bs_dx";
export var year = "bs_g0";